module.exports = __webpack_public_path__ + "static/media/qiwiD.d19a4033.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/qiwiD.svg
// module id = 395
// module chunks = 7